<script setup lang="ts">
import { watch } from "vue"

import { ALButton, ALModal } from "@af-lib/vue-ui"
import { storeToRefs } from "pinia"
import { usePreviousStateModalStore } from "./previousStateModal.store"
import { useRulesModalStore } from "@/components/af/RulesModal/rulesModal.store"

const { isActive } = storeToRefs(usePreviousStateModalStore())
const { closeRulesModal } = useRulesModalStore()
const { isRulesModalOpen } = storeToRefs(useRulesModalStore())

function onLeave() {
  window.location.href = "/"
}

watch(isActive, (newValue) => {
  if (newValue && isRulesModalOpen.value) {
    closeRulesModal()
  }
})
</script>

<template>
  <ALModal v-model="isActive" size="l" headerIcon="fat fa-calendar-clock">
    <template #header>
      <span class="text-af-grey-800 font-bold">
        {{ $t("general.quit.assessment.title") }}
      </span>
    </template>

    <template #content>
      <p class="text-af-grey-800 text-base font-light">
        {{ $t("general.quit.assessment.body") }}
      </p>
    </template>

    <template #footer>
      <ALButton type="tertiary" @click="isActive = false">
        {{ $t("general.cancel") }}
      </ALButton>
      <ALButton @click="onLeave">
        {{ $t("general.back") }}
      </ALButton>
    </template>
  </ALModal>
</template>
